import { Id, MessagesResponse } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { removeMessageDataFromCache } from 'chat/messages/queries/shared/utils'
import { useChatWebsocketContext } from 'chat/websocket/context'
import keys from './shared/keys'

export function useDeleteFile() {
  const { server } = useServer()
  const client = useQueryClient()
  const { sendWebsocketMessage } = useChatWebsocketContext()
  return useMutation({
    mutationFn: deleteFile,
    onSuccess: async removeMessageEvent => {
      if (removeMessageEvent) {
        await removeMessageDataFromCache(client, removeMessageEvent)
        sendWebsocketMessage({
          action: 'sendMessageEvent',
          messageEvent: removeMessageEvent,
        })
      }
      const repositoryKey = keys.all
      await client.invalidateQueries({ queryKey: repositoryKey })
    },
  })

  async function deleteFile({ fileId }: { fileId: Id }) {
    return server.delete<MessagesResponse.RemoveMessageEvent | undefined>(
      `/v2/chat/repository/files/${fileId}`
    )
  }
}

export function useDeleteFolder() {
  const { server } = useServer()
  const client = useQueryClient()
  const { sendWebsocketMessage } = useChatWebsocketContext()
  return useMutation({
    mutationFn: deleteFolder,
    onSuccess: async removeMessageEvent => {
      if (removeMessageEvent) {
        await removeMessageDataFromCache(client, removeMessageEvent)
        sendWebsocketMessage({
          action: 'sendMessageEvent',
          messageEvent: removeMessageEvent,
        })
      }
      const repositoryKey = keys.all
      await client.invalidateQueries({ queryKey: repositoryKey })
    },
  })

  async function deleteFolder({ folderId }: { folderId: Id }) {
    return server.delete<MessagesResponse.RemoveMessageEvent | undefined>(
      `/v2/chat/repository/folders/${folderId}`
    )
  }
}
